package io.horion.cv.models

data class SalaryRange(
    val min: Int,
    val max: Int,
    val currency: String = "CFA" // FCFA par défaut
)
